/*
 * Workspace help → Documentation entry. Doesn't host the docs in-app
 * — they live as a separate Docusaurus build at /docs/. This page is a
 * curated landing that points operators at the right section, plus an
 * "open the full site" button that leaves the SPA. Keeping the docs
 * outside the SPA means content can be authored as plain markdown
 * without round-tripping through React.
 */

import PageBreadcrumbs from "../layouts/PageBreadcrumbs.js";

const SECTIONS: Array<{ to: string; title: string; blurb: string }> = [
  {
    to: "/docs/",
    title: "Overview",
    blurb: "What the platform does and where to find each step in the UI."
  },
  {
    to: "/docs/architecture",
    title: "Architecture",
    blurb: "Postgres / Redis / ClickHouse layout, what each store holds, tenancy boundary."
  },
  {
    to: "/docs/pipeline",
    title: "The 5-step pipeline",
    blurb: "Pair instance → sync metadata → generate variables → ingest data → compute indicators."
  },
  {
    to: "/docs/tally-model",
    title: "Tally model",
    blurb: "Method × kind: what's being counted vs. how it's combined."
  },
  {
    to: "/docs/aggregate-domains",
    title: "Aggregate domains",
    blurb: "When to use auto-tally variables vs. curated rollup rules; the aggregateMode flag."
  },
  {
    to: "/docs/operations/deploying",
    title: "Operations: deploying",
    blurb: "release-deploy.sh, version gate, healthcheck, rollback."
  },
  {
    to: "/docs/operations/version-management",
    title: "Operations: version management",
    blurb: "version.mjs CLI, auto-suggest from commits, auto-CHANGELOG, tagging."
  },
  {
    to: "/docs/operations/troubleshooting",
    title: "Operations: troubleshooting",
    blurb: "Common diagnoses with the fastest path to fix."
  },
  {
    to: "/docs/reference/api",
    title: "Reference: API surface",
    blurb: "Endpoint catalog by category."
  },
  {
    to: "/docs/reference/data-model",
    title: "Reference: data model",
    blurb: "Tally definitions, buckets, indicators, source records — full type shapes."
  },
  {
    to: "/docs/reference/glossary",
    title: "Reference: glossary",
    blurb: "Quick definitions for every term in the system."
  }
];

export default function HelpDocs() {
  return (
    <div className="page">
      <PageBreadcrumbs />
      <header className="page-head">
        <div>
          <h1>Documentation</h1>
          <p className="muted">
            Comprehensive docs for the platform, including architecture, the data pipeline,
            tally model, operations runbooks, and the API reference.
          </p>
        </div>
        <div className="actions">
          <a href="/docs/" className="btn btn-primary">Open documentation →</a>
        </div>
      </header>
      <section
        style={{
          display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 12, marginTop: 12
        }}
      >
        {SECTIONS.map((s) => (
          <a
            key={s.to}
            href={s.to}
            className="card"
            style={{ padding: 16, textDecoration: "none", color: "inherit", display: "block" }}
          >
            <div style={{ fontWeight: 600, fontSize: 14 }}>{s.title}</div>
            <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>{s.blurb}</div>
            <div style={{ fontSize: 11, marginTop: 8, color: "#1e3a8a" }}>{s.to} →</div>
          </a>
        ))}
      </section>
    </div>
  );
}
